<div class="dropdown">
  <app-searchable-select [options]="selectOptions"
                         [value]="getSelectedCountryCode()"
                         [invalid]="control.invalid"
                         [clearable]="field?.config?.allowNull !== false || !field?.config?.hasOwnProperty('allowNull')"
                         [dataField]="field?.fieldUuid"
                         [dataTypeId]="field?.config?.typeId"
                         [ariaLabel]="field?.config?.label"
                         placeholder="Select a country..."
                         i18n-placeholder="@@country-select.placeholder"
                         (valueChange)="onSearchSelected($event)"></app-searchable-select>
</div>
